import React from "react";
import { Tooltip, Box, Chip } from "@mui/material";
import { MdFmdGood } from "react-icons/md";
import PcpLocationItem from "./PcpLocationItem";

const MapMarker = ({ selectHandler, practice, selectable, showPcps }) => {
  const [hover, onHover] = React.useState(false);

  return (
    <div
      className="map-marker"
      onClick={(e) => selectable && selectHandler(practice)}
      onMouseEnter={() => !hover && onHover(true)}
      onMouseLeave={() => hover && onHover(false)}
    >
      <Tooltip
        className="map-tooltip"
        disableFocusListener
        title={
          <Box>
            {hover && (
              <div>
                <PcpLocationItem practice={practice} />
                {showPcps && (
                  <Chip
                    className="chip-light"
                    label={
                      !practice.pcps.length
                        ? "0 Available PCPs"
                        : practice.pcps.length + " Available PCPs"
                    }
                  />
                )}
              </div>
            )}
          </Box>
        }
      >
        <div>
          <MdFmdGood className="pin" />
        </div>
      </Tooltip>
    </div>
  );
};

export default MapMarker;
